import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import solaimanLipiFontVfs from './solaimanLipiFontVfs';

pdfMake.vfs = {
    ...pdfFonts.pdfMake.vfs,
    'NotoSansBengali.ttf': solaimanLipiFontVfs,
}

pdfMake.fonts = {
    SulaimanLipi: {
        normal:      'NotoSansBengali.ttf',
        bold:        'NotoSansBengali.ttf',
        italics:     'NotoSansBengali.ttf',
        bolditalics: 'NotoSansBengali.ttf',
    },
    Roboto: {
        normal:      'Roboto-Regular.ttf',
        bold:        'Roboto-Medium.ttf',
        italics:     'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf',
    },
}

const txt = (str) => {
    if (!str) return [{ text: '-', font: 'Roboto' }]
    const segments = []
    const re = /([ঀ-৿⚠][ঀ-৿\s⚠]*|[^ঀ-৿⚠]+)/g
    let m
    while ((m = re.exec(str)) !== null) {
        const chunk = m[0]
        if (!chunk) continue
        const isBangla = /[ঀ-৿]/.test(chunk)
        segments.push({ text: chunk, font: isBangla ? 'SulaimanLipi' : 'Roboto' })
    }
    return segments.length ? segments : [{ text: str, font: 'Roboto' }]
}

const wasaApplicationPdf = () => {

    const downloadPdf = (master, generals, fieldLabels, applicationTypeLabel) => {
        const doc = buildDoc(master, generals, fieldLabels, applicationTypeLabel)
        pdfMake.createPdf(doc).download(`WASA-${master.tracking_no}.pdf`)
    }

    const buildDoc = (master, generals, fieldLabels, applicationTypeLabel) => {
        return {
            pageSize: 'A4',
            pageMargins: [40, 110, 40, 60],
            header: getHeader(),
            footer: getFooter(master),
            content: getContent(master, generals, fieldLabels, applicationTypeLabel),
            defaultStyle: { font: 'Roboto', fontSize: 10, color: '#1a1a1a' },
            styles: getStyles(),
        }
    }

    const getHeader = () => ({
        margin: [0, 0, 0, 0],
        stack: [
            {
                canvas: [{ type: 'rect', x: 0, y: 0, w: 595, h: 80, color: '#0d47a1' }],
                absolutePosition: { x: 0, y: 0 },
            },
            {
                margin: [40, 18, 40, 0],
                columns: [
                    {
                        stack: [
                            { text: txt('WASA সাধারণ আবেদন স্লিপ'), fontSize: 16, bold: true, color: '#ffffff' },
                            { text: 'Bangladesh Water Supply & Sewerage Authority', fontSize: 9, color: 'rgba(255,255,255,0.8)', margin: [0, 3, 0, 0], font: 'Roboto' },
                        ]
                    },
                    {
                        width: 'auto',
                        alignment: 'right',
                        stack: [
                            { text: 'WASA', fontSize: 22, bold: true, color: '#ffffff', opacity: 0.3, font: 'Roboto' },
                        ]
                    }
                ]
            }
        ]
    })

    const getFooter = (master) => ({
        margin: [40, 10, 40, 0],
        stack: [
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#0d47a1' }] },
            {
                margin: [0, 6, 0, 0],
                columns: [
                    { text: txt(`তারিখ: ${formatDate(master.created_at)}`), fontSize: 8, color: '#546e7a' },
                    { text: 'wasa@gov.bd  |  www.wasa.gov.bd', alignment: 'right', fontSize: 8, color: '#546e7a', font: 'Roboto' },
                ]
            }
        ]
    })

    const getContent = (master, generals, fieldLabels, applicationTypeLabel) => {
        const content = []

        content.push({
            margin: [0, 10, 0, 16],
            table: {
                widths: ['*'],
                body: [[{
                    border: [false, false, false, false],
                    fillColor: '#e3f2fd',
                    margin: [0, 0, 0, 0],
                    stack: [
                        { text: txt('আবেদন ট্র্যাকিং নম্বর'), fontSize: 9, color: '#546e7a', alignment: 'center', margin: [0, 10, 0, 4] },
                        { text: master.tracking_no, fontSize: 20, bold: true, color: '#0d47a1', alignment: 'center', letterSpacing: 3, font: 'Roboto' },
                        {
                            margin: [0, 4, 0, 10],
                            canvas: [{ type: 'rect', x: 150, y: 0, w: 215, h: 0, lineWidth: 1.5, lineColor: '#1976d2', dash: { length: 4 } }]
                        },
                    ]
                }]]
            },
            layout: { defaultBorder: false }
        })

        content.push({
            margin: [0, 0, 0, 14],
            columns: [
                { text: txt('আবেদনের ধরন:'), fontSize: 10, bold: true, color: '#37474f', width: 'auto' },
                {
                    margin: [8, -2, 0, 0],
                    table: {
                        body: [[{ text: txt(applicationTypeLabel), fontSize: 9, color: '#ffffff', bold: true, margin: [8, 3, 8, 3] }]]
                    },
                    layout: {
                        fillColor: () => '#0d47a1',
                        hLineWidth: () => 0,
                        vLineWidth: () => 0,
                    }
                }
            ]
        })

        content.push(sectionTitle('আবেদনকারীর তথ্য'))
        content.push(infoTable([
            ['নাম',               master.name],
            ['মোবাইল নং',        master.mobile],
            master.nid     ? ['জাতীয় পরিচয়পত্র নং', master.nid]     : null,
            master.address ? ['ঠিকানা',               master.address] : null,
            ['আবেদনের তারিখ',    formatDate(master.created_at)],
        ].filter(Boolean)))

        const filledGenerals = generals.filter(g => g.value)
        if (filledGenerals.length) {
            content.push({ text: '', margin: [0, 10] })
            content.push(sectionTitle('আবেদন সংক্রান্ত তথ্য'))
            content.push(infoTable(
                filledGenerals.map(g => [fieldLabels[g.key] || g.key, g.value])
            ))
        }

        content.push({
            margin: [0, 16, 0, 0],
            table: {
                widths: ['*'],
                body: [[{
                    fillColor: '#fff8e1',
                    border: [true, true, true, true],
                    borderColor: ['#f9a825', '#f9a825', '#f9a825', '#f9a825'],
                    margin: [10, 8, 10, 8],
                    text: txt('⚠  এই স্লিপটি আবেদনের প্রমাণ হিসেবে সংরক্ষণ করুন। আবেদনের অগ্রগতি জানতে ট্র্যাকিং নম্বরটি প্রয়োজন হবে।'),
                    fontSize: 9,
                    color: '#5d4037',
                }]]
            },
            layout: { defaultBorder: true }
        })

        content.push({
            margin: [0, 24, 0, 0],
            columns: [
                {
                    stack: [
                        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 160, y2: 0, lineWidth: 1, lineColor: '#37474f' }] },
                        { text: txt('আবেদনকারীর স্বাক্ষর'), fontSize: 9, color: '#546e7a', margin: [0, 4, 0, 0] },
                    ]
                },
                {
                    alignment: 'right',
                    stack: [
                        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 160, y2: 0, lineWidth: 1, lineColor: '#37474f' }] },
                        { text: txt('কর্তৃপক্ষের স্বাক্ষর ও সিল'), fontSize: 9, color: '#546e7a', margin: [0, 4, 0, 0], alignment: 'right' },
                    ]
                }
            ]
        })

        return content
    }

    const sectionTitle = (str) => ({
        table: {
            widths: ['*'],
            body: [[{
                text: txt(str),
                bold: true,
                fontSize: 9,
                color: '#ffffff',
                fillColor: '#1976d2',
                margin: [8, 5, 8, 5],
                border: [false, false, false, false],
            }]]
        },
        layout: { defaultBorder: false },
        margin: [0, 0, 0, 0],
    })

    const infoTable = (rows) => ({
        table: {
            widths: ['35%', '65%'],
            body: rows.map(([label, value], i) => [
                {
                    text: txt(label),
                    bold: true,
                    fontSize: 9,
                    color: '#37474f',
                    fillColor: i % 2 === 0 ? '#f5f9ff' : '#ffffff',
                    margin: [8, 6, 8, 6],
                    border: [true, false, true, true],
                    borderColor: ['#bbdefb', '#bbdefb', '#bbdefb', '#bbdefb'],
                },
                {
                    text: txt(String(value || '-')),
                    fontSize: 9,
                    color: '#1a1a1a',
                    fillColor: i % 2 === 0 ? '#f5f9ff' : '#ffffff',
                    margin: [8, 6, 8, 6],
                    border: [false, false, true, true],
                    borderColor: ['#bbdefb', '#bbdefb', '#bbdefb', '#bbdefb'],
                },
            ])
        },
        layout: { defaultBorder: false },
    })

    const getStyles = () => ({
        header: { fontSize: 16, bold: true },
    })

    const formatDate = (dateStr) => {
        if (!dateStr) return '-'
        const d = new Date(dateStr)
        return d.toLocaleDateString('bn-BD', { day: '2-digit', month: 'long', year: 'numeric' })
    }

    return { downloadPdf }
}

export default wasaApplicationPdf
